// Plantarium
export const PlantTraitHiddenIntellect = 'PlantTraitHiddenIntellect';
export const PlantTraitHiddenCarnivorous = 'PlantTraitHiddenCarnivorous';

export const PlantTraitRootVegetable = 'PlantTraitRootVegetable';
export const PlantTraitHoney = 'PlantTraitHoney';
export const PlantTraitMycorrhiza = 'PlantTraitMycorrhiza';
export const PlantTraitAquatic = 'PlantTraitAquatic';
export const PlantTraitOfficinalis = 'PlantTraitOfficinalis';
export const PlantTraitProteinRich = 'PlantTraitProteinRich';
export const PlantTraitTree = 'PlantTraitTree';
export const PlantTraitParasiticPlant = 'PlantTraitParasiticPlant';
export const PlantTraitSpiky = 'PlantTraitSpiky';

export const PlantTraitParasiticLink = 'PlantTraitParasiticLink';